export const FALCONS_PORTFOLIO_PROJECT_PAGE = 'falcons_portfolio_project_page';
export const ENABLE_WORK_SAMPLE = 'qualas_enable_portfolios_work_samples';
export const CARIBOU_PORTFOLIO_ATTACHMENT_REPORT = 'caribou_portfolio_attachment_report_eligibility';
export const DISABLE_PORTFOLIO_PROJECT_MODERATION = 'disable_portfolio_project_moderation';
export const CHEETAHS_PROFESSIONS = 'cheetahs_professions';
export const CHEETAHS_PROFESSIONS_BUYER_SIDE = 'cheetahs_professions_buyer_side';

/**
 * App rollouts.
 */
export const ROLLOUTS = {
    FALCONS_PORTFOLIO_PROJECT_PAGE,
    ENABLE_WORK_SAMPLE,
    CARIBOU_PORTFOLIO_ATTACHMENT_REPORT,
    DISABLE_PORTFOLIO_PROJECT_MODERATION,
    CHEETAHS_PROFESSIONS,
    CHEETAHS_PROFESSIONS_BUYER_SIDE,
} as const;

export type Rollouts = (typeof ROLLOUTS)[keyof typeof ROLLOUTS];
